<!-- We'll want our page wrapped in the app-page component which handles errors. -->
<app-page [(error)]="error">

  <!-- Define our page card. -->
  <mat-card>

    <!-- Define the header of our page card. -->
    <mat-card-header>

      <!-- Give our page an icon. -->
      <mat-icon mat-card-avatar color="icon-orange">logout</mat-icon>

      <!-- Give our page a main title. -->
      <mat-card-title>You have been signed out.</mat-card-title>

      <!-- Give our page a very short description. -->
      <mat-card-subtitle>All information regarding your session has been purged.</mat-card-subtitle>
    </mat-card-header>

    <!-- Define the content of our page card. -->
    <mat-card-content>

    </mat-card-content>
  </mat-card>
</app-page>
